<template>
  <v-textarea
    v-model="localValue"
    :append-icon="input.appendIcon"
    :auto-grow="true"
    :class="['input']"
    color="accent"
    dense
    filled
    :label="input.displayName"
    :hint="input.displayName"
    :prefix="input.prefix"
    :prepend-inner-icon="input.prependIcon"
    :required="input.required"
    :suffix="input.suffix"
    :to="input.to"
  >
    {{ localValue }}
  </v-textarea>
</template>

<script>
export default {
  name: "TextArea",

  props: {
    input: {
      type: Object,
      required: false,
    },
  },

  computed: {
    localValue: {
      get() {
        return this.input.value
      },
      set(newValue) {
        this.$emit("update:value", newValue)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.input {
  margin-bottom: -30px;
}
.v-text-field--filled .v-text-field__prefix,
.v-text-field--filled .v-text-field__suffix {
  margin-top: 0px;
}
</style>
